import request from '@/axios'

export function notificationTemplateShow (customer_id, template_id) {
  return request({
    url: `/communication/template/show/${customer_id}/${template_id}/PUSH`,
    method: 'GET'
  })
}

export function notificationTemplateList (customer_id, page, limit, sorting_obj = {},  payload, table_name) {
  let url = ''
  if (Object.entries(sorting_obj).length > 0) {
    url = `/communication/template/list/${customer_id}/PUSH?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`
  } else {
    url = `/communication/template/list/${customer_id}/PUSH?page=${page}&limit=${limit}`
  }
  return request({
    url,
    method: 'POST',
    data:payload
  })
}

export function notificationDynamicFieldList (customer_id) {
  return request({
    url: `/emailDynamicFields/list/${customer_id}`,
    method: 'GET'
  })
}

export function notificationTypeList () {
  return request({
    url: '/emailType/list',
    method: 'GET'
  })
}

export function notificationTemplateCreate (customer_id, query) {
  return request({
    url: `/communication/template/create/${customer_id}/PUSH`,
    method: 'POST',
    data: query
  })
}

export function notificationTemplateEdit (customer_id, template_id, query) {
  return request({
    url: `/communication/template/edit/${customer_id}/PUSH/${template_id}`,
    method: 'POST',
    data: query
  })
}


export function notificationMapFields (customer_id, query) {
  return request({
    url: `/communication/map/fields/${customer_id}/PUSH`,
    method: 'POST',
    data: query
  })
}

export function notificationTemplateDelete (customer_id, query) {
  return request({
    url: `/communication/template/delete/${customer_id}/PUSH`,
    method: 'POST',
    data: query
  })
}

